import * as React from "react";
import { forwardRef } from "react";
const SvgContains = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.33301 2.5V5.83333H4.99967V4.16667H9.16634V15.8333H7.49967V17.5H12.4997V15.8333H10.833V4.16667H14.9997V5.83333H16.6663V2.5H3.33301Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgContains);
export default ForwardRef;
